import React from "react";
import PropTypes from 'prop-types';
import ThreadFile from "../../Util/ThreadFile";
import {FormattedMessage} from 'react-intl';

const File = ({threadFile}, {translations}) => (
    <div className='media-body'>
        <div>
            <FormattedMessage id="thread.file_uploaded"/>: &nbsp;<ThreadFile threadFile={threadFile}/>
        </div>
    </div>
);

File.propTypes = {
    threadFile: PropTypes.any.isRequired
};

export default File;
